import { Dispatch } from 'redux';
import { isEmpty } from 'lodash';
import { regionActions } from '../slices/region-slice';
import { ApiRegion } from '../http';

const {
  setRegionRequestStart,
  setRegionRequestSuccess,
  setRegionRequestFailure,
  setRegionRequestDefault,

  setRegionListRequest,
  setRegionListSuccess,
  setRegionListFailure,
  setRegionListDefault,

  setRegionOneRequest,
  setRegionOneSuccess,
  setRegionOneFailure,
  setRegionOneDefault,

  setRegionWarehouseRequest,
  setRegionWarehouseSuccess,
  setRegionWarehouseFailure,
  setRegionWarehouseDefault,
} = regionActions;

//List
export const getRegions = (params: Record<string, any>) => async (dispatch: Dispatch<any>) => {
  dispatch(setRegionListRequest());
  try {
    const data = await ApiRegion.fetchAll(params);
    dispatch(setRegionListSuccess(data));
  } catch ({ message }) {
    dispatch(setRegionListFailure({ message }));
  }
};
export const clearRegions = () => async (dispatch: Dispatch<any>) => {
  dispatch(setRegionListDefault());
};

//One
export const getRegion = (id: string | number) => async (dispatch: Dispatch<any>) => {
  dispatch(setRegionOneRequest());
  try {
    const data = await ApiRegion.fetchOne(id);
    dispatch(setRegionOneSuccess(data));
  } catch ({ message }) {
    dispatch(setRegionOneFailure({ message }));
  }
};
export const clearRegion = () => async (dispatch: Dispatch<any>) => {
  dispatch(setRegionOneDefault());
};

//Warehouse
export const forceGetRegionWarehouse = () => async (dispatch: Dispatch<any>) => {
  dispatch(setRegionWarehouseRequest());
  try {
    const data = await ApiRegion.fetchAll({ take: 9999 });
    dispatch(setRegionWarehouseSuccess(data));
  } catch ({ message }) {
    dispatch(setRegionWarehouseFailure({ message }));
  }
};
export const getRegionWarehouse = () => async (dispatch: Dispatch<any>, getState: any) => {
  const storeStates = getState();
  const { warehouse } = storeStates.region;
  if (isEmpty(warehouse.hits) && !warehouse.isLoading) {
    dispatch(forceGetRegionWarehouse());
  }
};
export const clearRegionWarehouse = () => async (dispatch: Dispatch<any>) => {
  dispatch(setRegionWarehouseDefault());
};

//Create
export const createRegion = (data: Record<string, any>) => async (dispatch: Dispatch<any>) => {
  dispatch(setRegionRequestStart());
  return new Promise((resolve, reject) => {
    ApiRegion.createOne(data)
      .then((res) => {
        dispatch(setRegionRequestSuccess());
        resolve(res);
      })
      .catch((res) => {
        dispatch(setRegionRequestFailure({ message: res?.message }));
        reject(res);
      });
  });
};

//Edit
export const editRegion =
  (id: string | number, data: Record<string, any>) => async (dispatch: Dispatch<any>) => {
    dispatch(setRegionRequestStart());
    return new Promise((resolve, reject) => {
      ApiRegion.updateOne(id, data)
        .then((res) => {
          dispatch(setRegionRequestSuccess());
          resolve(res);
        })
        .catch((res) => {
          dispatch(setRegionRequestFailure({ message: res?.message }));
          reject(res);
        });
    });
  };

//Delete
export const deleteRegion = (id: string | number) => async (dispatch: Dispatch<any>) => {
  dispatch(setRegionRequestStart());
  return new Promise((resolve, reject) => {
    ApiRegion.deleteOne(id)
      .then((res) => {
        dispatch(setRegionRequestSuccess());
        resolve(res);
      })
      .catch((res) => {
        dispatch(setRegionRequestFailure({ message: res?.message }));
        reject(res);
      });
  });
};

//Clear request
export const clearRegionRequest = () => async (dispatch: Dispatch<any>) => {
  dispatch(setRegionRequestDefault());
};
